import { useNavigate } from 'react-router-dom';

export default function AboutSection() {
  const navigate = useNavigate();

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="text-xs font-medium tracking-wider uppercase text-secondary-600 font-label">About the System</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-800 leading-[1.15] mt-3 tracking-tight">
            Smart Shopping
            <br />
            Starts With
            <br />
            Mulebuy Spreadsheet
          </h2>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            Visit Official Platform
          </a>
          <button
            type="button"
            onClick={() => navigate('/what-is-mulebuy-spreadsheet')}
            className="px-7 py-3 rounded-full border border-primary-500/40 text-primary-700 text-sm font-medium cursor-pointer hover:bg-primary-50 transition-all duration-200 whitespace-nowrap"
          >
            Read the Full Guide
          </button>
        </div>

        <div className="mt-12 max-w-2xl">
          <p className="text-base text-foreground-700 leading-relaxed">
            The <strong>Mulebuy Spreadsheet</strong> system has become one of the most efficient methods for managing cross-border product sourcing. By using a structured spreadsheet-based workflow, users can compare suppliers, track orders, and optimize purchasing decisions more effectively than traditional methods.
          </p>
          <p className="mt-5 text-base text-foreground-700 leading-relaxed">
            Whether you are sourcing shoes, apparel, accessories, or lifestyle products, the <strong>Mulebuy Spreadsheet</strong> approach gives you complete visibility over your entire shopping journey. From initial product discovery to final delivery tracking, every step is organized and transparent.
          </p>
          <p className="mt-5 text-base text-foreground-700 leading-relaxed">
            Our comprehensive guides help beginners understand the fundamentals while providing advanced users with optimization strategies. 
            <a href="/what-is-mulebuy-spreadsheet" className="text-primary-500 font-medium hover:text-primary-600 transition-colors duration-200 cursor-pointer ml-1">
              Explore Mulebuy Spreadsheet system
            </a>
            {' '}and start shopping smarter today.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <div className="text-2xl font-bold text-primary-500 font-heading">14+</div>
            <div className="text-xs text-foreground-500 mt-1">Product Categories</div>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <div className="text-2xl font-bold text-primary-500 font-heading">3,500+</div>
            <div className="text-xs text-foreground-500 mt-1">Products Listed</div>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <div className="text-2xl font-bold text-primary-500 font-heading">2026</div>
            <div className="text-xs text-foreground-500 mt-1">Updated Insights</div>
          </div>
          <div className="bg-background-100 rounded-xl p-5 text-center">
            <div className="text-2xl font-bold text-primary-500 font-heading">Free</div>
            <div className="text-xs text-foreground-500 mt-1">Guide & Resources</div>
          </div>
        </div>
      </div>
    </section>
  );
}